export default __webpack_public_path__ + "static/media/SLIDE_ESCALERAS_3.d43b58fc.JPG";